import dayjs from "dayjs";

/* * * 3.代表返回上级
 * 4代表的是邀请好友方法,5代表调到首页,6代表跳转到登陆页面,7跳转到开户地址,8代表跳到充值页面
 * */

export const backApp = (flag) => {
  if (window.isNative && window.isNative.ResultByJs) {
    //andriod
    window.isNative.ResultByJs(flag);
  }
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.ResultByJs
  ) {
    window.webkit.messageHandlers.ResultByJs.postMessage({ body: flag });
  }
  if (window.ResultByJs) {
    //ios
    window.ResultByJs(flag);
  }
};

export const formatPhone = (tel) => {
  tel = "" + tel;
  var ary = tel.split("");
  ary.splice(3, 4, "****");
  var tel1 = ary.join("");
  return tel1;
};

export const bonusType = (val) => {
  switch (val) {
    case "1":
      return "bonus";
    case "2":
      return "cashBack";
    default:
      return "";
  }
};

export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

export const formateDate = (date) => {
  const nowYear = new Date().getFullYear();
  const dataArr = date.split(" ")[0].split("-");
  const timeArr = date.split(" ")[1].split(":");
  let data;
  let hourArr = timeArr.splice(0, 2);
  if (nowYear == dataArr[0]) {
    let monthArr = dataArr.splice(1, 2);
    data = `${monthArr.join("/")} ${hourArr.join(":")}`;
  } else {
    data = `${dataArr.join("/")} ${hourArr.join(":")}`;
  }
  return data;
};

export const formatMail = (mail) => {
  let useMail = "";
  if (typeof mail !== "string") return (useMail = mail);
  const mailLength = mail.split("@")[0].length;
  const numMail = mail.split("@")[0];
  if (mailLength < 2) {
    useMail = `${numMail}***`;
  } else if (mailLength < 5) {
    let numArr = numMail.split("");
    let first = numMail.slice(0, 1);
    let last = numMail.slice(numMail.length - 1);
    useMail = `${first}***${last}`;
  } else {
    let first = numMail.slice(0, 2);
    let last = numMail.slice(numMail.length - 3);
    useMail = `${first}***${last}`;
  }
  useMail = `${useMail}@${mail.split("@")[1]}`;
  return useMail;
};

export const formatDuring = function (time) {
  if (isNaN(time) || time <= 0) {
    return {
      day: 0,
      hours: 0,
      minus: 0,
      second: 0,
    };
  }
  const HOUR = 60 * 60;
  const day = parseInt(time / (HOUR * 24));
  const hours = parseInt((time % (HOUR * 24)) / HOUR);
  const minus = parseInt((time % HOUR) / 60);
  const second = parseInt(time % 60);
  return {
    day,
    hours,
    minus,
    second,
  };
};

export const callAppMethod = (type = "", data = {}) => {
  if (window.isNative) {
    window.isNative.toAppPage &&
      window.isNative.toAppPage(JSON.stringify({ type, data }));
  }
  if (window.webkit && window.webkit.messageHandlers.toAppPage) {
    window.webkit.messageHandlers.toAppPage.postMessage({
      type,
      data,
    });
  }
};

export const formatDate = (time, split = "-") => {
  const date = new Date((time + "").replace(/(\+\d{2})(\d{2})$/, "$1:$2"));
  const year = date.getFullYear() + "";
  const month = date.getMonth() + 1 + "";
  const today = date.getDate() + "";
  const hours = date.getHours() + "";
  const minu = date.getMinutes() + "";
  const sec = date.getSeconds() + "";
  return {
    format: `${year}${split}${month.padStart(2, "0")}${split}${today.padStart(
      2,
      "0"
    )}`,
    formatTime: `${year}${split}${month.padStart(
      2,
      "0"
    )}${split}${today.padStart(2, "0")} ${hours.padStart(
      2,
      "0"
    )}:${minu.padStart(2, "0")}:${sec.padStart(2, "0")}`,
  };
};

/**
 * 毫秒转化成 年/月/日 时:分:秒
 * @param {string} time 时间毫秒
 */

export const formatTime = (time) => {
  if (!time) {
    return null;
  }
  return dayjs(time).format("YYYY/MM/DD HH:mm:ss");
};



// WEBPACK FOOTER //
// ./src/utils/index.js